import { request } from "../api";
import { MESSAGE } from "../../../constants/api/message";

const { post, get } = request;
const initialRoute = "ai/gemini";

export const getJsonFromBackend = async (csv_text: string, prompt: string) => {
	try {
		const endpoint = `${initialRoute}/get-json`;

		const token = localStorage.getItem("@jwt");
		const response = await post(
			endpoint,
			{ csv_text, prompt },
			{
				Authorization: `Bearer ${token || ""}`
			}
		);

		if (!response) {
			throw new Error("No response from server");
		}
		console.log("genime 3", response);
		return response.data;
	} catch (err: any) {
		console.error("API Error:", err.response?.data || err.message);
		throw err;
	}
};
